import Vue from "vue"
import Resource from "vue-resource"

Vue.use(Resource)

export const ssv2300ConfiOpedaWsResource = Vue.resource("rest/ssv2300-confi-opeda-wss{/id}");

export const ssv2307UsuroCadtrCrtorResource = Vue.resource("rest/ssv2307-usuro-cadtr-crtors{/id}");

export const ssv2308ExcecRadarCotacResource = Vue.resource("rest/ssv2308-excec-radar-cotacs{/id}");

export const ssv2314CadtrFlagWsResource = Vue.resource("rest/ssv2314-cadtr-flag-wss{/id}");

export const ssv2340ConfiCrtorWsResource = Vue.resource("rest/ssv2340-confi-crtor-wss{/id}");

export const ssv2341ConfiCrtorFlagWsResource = Vue.resource("rest/ssv2341-confi-crtor-flag-wss{/id}");

export const ssv2303ConfiAutoFncraResource = Vue.resource("rest/ssv2303-confi-auto-fncras{/id}");